const toArray = <T>(obj: Record<string, T>): T[] =>
  obj ? Object.keys(obj).map(key => obj[key]) : []

export default toArray
